import React from 'react';
import PropTypes from 'prop-types';

const API_URL = process.env.REACT_APP_CMS;

const OfferDetailsIcons = ({ item }) => (
    <div className="offer-details-icons">
        <h1 className="offer-details-icons-title" dangerouslySetInnerHTML={ { __html: item.translations.use_case_description } }/>
        <div className="offer-details-icons-container">
            {
                item.use_cases.map((elem, number) => (
                    <div className="offer-details-icons-content" key={ `offer-details-icons-content-${ number }` }>
                        <span
                          className="offer-details-icons-icon"
                        >
                            <img src={ `${ API_URL }/assets/${ elem.icon }` } alt={ elem.translations.name }/>
                        </span>
                        <h2 className="offer-details-icons-icon-title">{ elem.translations.name }</h2>
                    </div>
                ))
            }
        </div>
    </div>
);

OfferDetailsIcons.propTypes = {
    item: PropTypes.shape().isRequired
};

export default OfferDetailsIcons;



// WEBPACK FOOTER //
// ./src/components/content/offer/details/OfferDetailsIcons.jsx